import api from '@/utils/api';
import {
    LOGIN,
    LOGOUT,
    GET_AUTH_USER,
    CHANGE_PASSWORD,
    RESET_PASSWORD,
    UPDATE_AUTH_USER,
    CHANGE_PIN_CODE,
    RESET_PIN_CODE
} from './types';
import { setCookie, removeCookie } from '@/utils/cookie';
import { NotificationManager } from 'react-notifications';

const getAuthErrorMessage = (err) => (
    err?.response?.data?.msg ||
    err?.response?.data?.message ||
    err?.message ||
    "Đã có lỗi xảy ra, vui lòng thử lại!"
);

const getLoginPayload = (res) => res?.data?.data || res?.data || null;

export const login = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/login', data).then(res => {
            const payload = getLoginPayload(res);

            if (!payload?.user) {
                throw new Error(res?.data?.msg || 'Dữ liệu đăng nhập trả về không hợp lệ!');
            }

            if (payload?.token) {
                setCookie('chingo_dental_token', payload.token, 1);
            }

            dispatch({ type: LOGIN, payload });
            resolve(true)
        }).catch(err => {
            NotificationManager.error(getAuthErrorMessage(err));
            reject(err);
        })
    })
}

export const getAuthUser = () => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/auth').then(res => {
            //console.log("REs: ",res.data.data)
            dispatch({ type: GET_AUTH_USER, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            //console.log(err.response)
            // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
            reject(err);
        })
    })
}

export const updateAuthUser = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put('/auth', data).then(res => {
            dispatch({ type: UPDATE_AUTH_USER, payload: res.data.data });
            NotificationManager.success("Cập nhật thành công!");
            resolve(true)
        }).catch(err => {
            //console.log(err.response)
            // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
            reject(err);
        })
    })
}

export const changePassword = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/change-password', data).then(res => {
            dispatch({ type: CHANGE_PASSWORD, payload: res.data.data });
            NotificationManager.success("Thay đổi mật khẩu thành công!");
            resolve(true)
        }).catch(err => {
            NotificationManager.error(getAuthErrorMessage(err));
            reject(err);
        })
    })
}

export const changePinCode = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/change-pin-code', data).then(res => {
            dispatch({ type: CHANGE_PIN_CODE, payload: res.data.data });
            NotificationManager.success("Thay đổi mã pin thành công!");
            resolve(true)
        }).catch(err => {
            NotificationManager.error(getAuthErrorMessage(err));
            reject(err);
        })
    })
}

export const resetPassword = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/reset-password', data).then(res => {
            dispatch({ type: RESET_PASSWORD, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            //console.log(err);
            NotificationManager.error(getAuthErrorMessage(err));
            reject(err);
        })
    })
}

export const resetPincode = () => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/reset-pin-code').then(res => {
            dispatch({ type: RESET_PIN_CODE, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            //console.log(err);
            NotificationManager.error(getAuthErrorMessage(err));
            reject(err);
        })
    })
}

export const logout = () => dispatch => {
    return new Promise((resolve, reject) => {
        removeCookie('chingo_dental_token');
        dispatch({ type: LOGOUT });
        resolve(true);
    })
}
